import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import './LockPayment.scss';
import PaymentActions from 'pgdb-data-layer/lib/Redux/PaymentRedux';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import Loading from '../../../Components/Loading';
import { getToken } from '../../../Session/SessionRedux';
import Navigator from '../../../Navigation/Navigator';

const LockPaymentSuccess = ({ getPaymentLockRequest, token, userContactData }) => {
   const [hasDispatched, setHasDispatched] = useState(false);
   const isLoading = !hasDispatched;

   useEffect(() => {
      if (userContactData && userContactData.contactId) {
         getPaymentLockRequest(userContactData.contactId, token);
      }
      setHasDispatched(true);
   }, [token]);

   const importantNote = () => {
      return (
         <div className="important-note">
            <div className="important-note-header">
               <ErrorOutlineIcon />
               <b>Important Note</b>
            </div>
            <div className="important-note-content">
               <p>
                  Please check your email and your dashboard regularly to avoid
                  missing any important update.
               </p>
            </div>
            <footer className="important-note-footer">
               If you need help, call us on our free phone{' '}
               <span className="important-note-phone">
                  <a href="tel:0800743262" rel="nofollow">
                     0800 743 262
                  </a>{' '}
               </span>
               or email{' '}
               <a
                  className="activeblue-text important-note-email"
                  href="mailto:licensing@pgdb.co.nz"
               >
                  licensing@pgdb.co.nz
               </a>
            </footer>
         </div>
      );
   };

   return (
      <main>
         <Loading isLoading={isLoading}>
            <div className="section no-pad-bot" id="index-banner">
               <div className="container lock-payment-container">
                  <div className="row no-margin">
                     <div className="col l9 m8 s12">
                        <div className="col m9 offset-l1 s12">
                           <h4 className="columnheader lock-payment-header">
                              Congratulations! Your payment is successful.
                           </h4>
                        </div>
                        <div className="col m10 l9 offset-l1 s11">
                           <div className="success-page-description">
                              <p>
                                 Please download your GST receipt under your profile in the trade login.
                              </p>
                           </div>
                           <div className="row lock-payment-type-profile-row next-button-lock-payment right">
                              <div className="navigate-buttons">
                                 <button
                                    type="button"
                                    className="waves-effect waves-light button-margin btn"
                                    onClick={() => Navigator.toDashboard()}
                                 >
                                    HOME
                                 </button>
                              </div>
                           </div>
                        </div>
                     </div>
                     <div className="col l3 m4 side-note-background">
                        {importantNote()}
                     </div>
                  </div>
               </div>
            </div>
         </Loading>
      </main>
   );
};

const mapStateToProps = state => {
   return {
      token: getToken(state),
      userContactData: state.user.userInfo || {},
   };
};

const mapDispatchToProps = {
   getPaymentLockRequest: PaymentActions.getPaymentLockRequest,
};

export default connect(
   mapStateToProps,
   mapDispatchToProps
)(LockPaymentSuccess);
